const getAddressFromCoordinates = (
  lat: number | string,
  lng: number | string,
): Promise<string> => new Promise((resolve, reject) => {
  if (!window.google || !window.google.maps) {
    reject(new Error('Google Maps JavaScript API not loaded'))
    return
  }

  const geocoder = new window.google.maps.Geocoder()
  const location = {
    lat: typeof lat === 'string' ? parseFloat(lat) : lat,
    lng: typeof lng === 'string' ? parseFloat(lng) : lng,
  }

  geocoder.geocode({ location }, (results, status) => {
    if (status === 'OK' && results && results[0]) {
      resolve(`${results[0].formatted_address}付近`)
    } else if (status === 'ZERO_RESULTS') {
      reject(new Error('住所が見つかりませんでした'))
    } else {
      reject(new Error(`Geocoding failed: ${status}`))
    }
  })
})

export default getAddressFromCoordinates
